import { useTranslation } from "_metronic/i18n/language";
import moment from "moment";
import { useCallback, useState } from "react";
import { useHistory } from "react-router-dom";

export interface MiniScentDevice {
  miniscentDeviceId: number;
  serialNumber: string;
  name: string;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
}

export type DeviceStatus = "online" | "offline" | "inactive";

type TranslateFunction = ReturnType<typeof useTranslation>;

const getDeviceStatus = (deletedAt: string | null): DeviceStatus => {
  if (deletedAt) {
    return "inactive";
  } else {
    return "online";
  }
};

const getStatusColor = (status: DeviceStatus): "success" | "default" => {
  switch (status) {
    case "online":
      return "success";
    case "inactive":
    default:
      return "default";
  }
};

const getStatusLabel = (
  status: DeviceStatus,
  translate: TranslateFunction,
): string => {
  switch (status) {
    case "online":
      return "Online"; // translate("screens.device.status.online")
    case "offline":
      return "Offline"; // translate("screens.device.status.offline")
    case "inactive":
      return "Inativo"; // translate("screens.device.status.inactive")
    default:
      return status;
  }
};

const useMiniScentModel = () => {
  const [miniScentDevices, setMiniScentDevices] = useState<MiniScentDevice[]>(
    [],
  );
  const [reload, setReload] = useState<boolean>(false);
  const translate = useTranslation();
  const history = useHistory();

  const handleViewDetails = useCallback(
    (deviceId: number) => {
      history.push(`/admin/miniscent/devices/${deviceId}`);
    },
    [history],
  );

  return {
    translate,
    miniScentDevices,
    reload,
    getStatusLabel,
    setMiniScentDevices,
    setReload,
    handleViewDetails,
    getDeviceStatus,
    getStatusColor,
  };
};

export default useMiniScentModel;
